<template>
  <v-main class="pt-7 px-3">
    <div class="d-flex align-center justify-center">
      <v-btn small fab color="tertiary" dark elevation="0" class="back-icon" @click="goToDashboard()">
        <v-icon color="primary">mdi-chevron-left</v-icon>
      </v-btn>
      <div class="page-title">
        Upload de atestados
      </div>
    </div>
    <div class="mt-7 d-flex justify-center text-center">
      <div
        class="tab-item"
        v-for="tab in tabs"
        :key="tab.value"
        @click="setActiveTabItem(tab.value)"
        :style="tab.value === activeTab ? { backgroundColor } : { backgroundColor: '#fff' }"
      >
        {{ tab.text }}
      </div>
    </div>
    <UploadAtestado v-if="activeTab === 'upload-atestado'" key="upload-atestado" :atestadoId="atestadoId" />
    <ListarAtestados v-else-if="activeTab === 'listar-atestados'" key="listar-atestados" @on-click-edit="onClickEdit" />
  </v-main>
</template>

<script>
import UploadAtestado from './components/UploadAtestadoStepper'
import ListarAtestados from './components/ListarAtestados'

export default {
  name: 'Atestado',
  components: {
    UploadAtestado,
    ListarAtestados
  },
  data() {
    return {
      atestadoId: null,
      headers: [
        {
          text: 'Data de criação',
          align: 'start',
          sortable: false,
          value: 'dtCriação'
        },
        {
          text: 'CID (Patologia)',
          align: 'start',
          sortable: false,
          value: 'cids'
        },
        { text: 'Data de emissão', value: 'dtEmissao', sortable: false },
        { text: 'Dias de afastamento', value: 'diasAfastamento', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      atestados: [],
      activeTab: 'upload-atestado',
      tabs: [
        {
          text: 'Enviar um atestado',
          value: 'upload-atestado'
        },
        {
          text: 'Meus atestados',
          value: 'listar-atestados'
        }
      ],
      backgroundColor: this.$vuetify.theme.themes.light.primary
    }
  },
  methods: {
    onClickEdit(atestadoId) {
      this.atestadoId = atestadoId
      this.activeTab = 'upload-atestado'
    },
    goToDashboard() {
      this.$router.push('dashboard')
    },
    setActiveTabItem(tab) {
      this.atestadoId = null
      this.activeTab = tab
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 1.25rem;
  justify-self: center;
}
.back-icon {
  position: absolute;
  left: 0;
  margin-left: 1vw;
}
.tab-item {
  background-color: #f0f6fa;
  color: #c9c9c9;
  text-align: center;
  padding: 5px;
  width: 50%;
  cursor: pointer;
}
.tab-item-active {
  color: #fff;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
